import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  body: string;
  action?: ReactNode;
}

/**
 * Designed empty state (foundations.md §7.11): icon, short headline,
 * one-line explanation, optional primary action — never a blank panel or a
 * bare "No data".
 */
export function EmptyState({ icon, title, body, action }: EmptyStateProps) {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ py: 8, px: 3, textAlign: 'center' }}>
      <Box sx={{ color: 'text.secondary', fontSize: 40, lineHeight: 0 }}>
        {icon ?? <InboxOutlinedIcon fontSize="inherit" />}
      </Box>
      <Typography variant="h6" component="p" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        {body}
      </Typography>
      {action}
    </Stack>
  );
}
